import classNames from 'classnames';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useElementSize } from 'usehooks-ts';

type GroupedListRowProps = {
  children: React.ReactNode;
  row?: boolean;
  column?: boolean;
};

const GROUPED_LIST_HEADLINE_HEIGHT = '32rem';

const GroupedListRow: React.FC<React.PropsWithChildren<GroupedListRowProps>> = ({ children, row, column }) => {
  const { ref, inView } = useInView({ threshold: 0, initialInView: true });

  const [sizeRef, { height }] = useElementSize();

  const setRefs = React.useCallback(
    (node: HTMLDivElement) => {
      sizeRef(node);
      ref(node);
    },
    [ref, sizeRef],
  );

  const isHeadline = React.useMemo(() => typeof children === 'string', [children]);

  const className = classNames({
    'grouped-list__row grouped-list__row--asset': row && !isHeadline,
    'grouped-list__column grouped-list__column--asset': column && !isHeadline,
    'grouped-list__row grouped-list__row--headline': isHeadline,
  });

  const minHeight = React.useMemo(() => (isHeadline ? GROUPED_LIST_HEADLINE_HEIGHT : height), [height, isHeadline]);

  if (isHeadline) {
    return (
      <div ref={setRefs} style={{ minHeight }} className={className} data-test='grouped-list__headline'>
        {inView && <h4 className='Body2_reg_12 grouped-list__row-headline'>{children}</h4>}
      </div>
    );
  }

  return (
    <div ref={setRefs} style={{ minHeight }} className={className} data-test='grouped-list__row'>
      {inView && children}
    </div>
  );
};

export default React.memo(GroupedListRow);
